import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import {
  IAuthDataRequest,
  IBlockRequest,
  ICityResponse,
  ICodeGenerator,
  ICountryResponse,
  IEmployeeMasterFilterParams,
  IEmployeeResponse,
  IEventResponse,
  IExceptionResponse,
  IOdaResponse,
  IOwnerRequest,
  IProductResponse,
  IRegionResponse,
  ISearchEmployeeRequest,
  IStationResponse,
  ITripRouteResponse,
  IVehicleMasterFilterParams,
  IVehicleResponse,
  IVehicleTypeRequest
} from '../model/MasterModel';
import AjexPortalService from "./api";
import config from './config';
import { PaginationParams } from '../model/CommonModel';

const exceptionReason = config.get('exceptionReason');
const customer = config.get('customer');
const employee = config.get('employee');
const filter = config.get('filter');
const vehicle = config.get('vehicle');
const event = config.get('event');
const tripRoute = config.get('tripRoute');
const city = config.get('city');
const country = config.get('country');
const odaCity = config.get('odaCity');
const region = config.get('region');
const product = config.get('product');
const customerListViewUser = config.get('customerListViewUser');
const index = config.get('pageNumber');
const count = config.get('pageSize');
const paginated = config.get('paginated');
const page = config.get('page');
const size = config.get('size');
const station = config.get('station');
const blockCustomer = config.get('blockCustomer');
const unBlockCustomer = config.get('unBlockCustomer');
const block = config.get('block');
const subAccount = config.get('subAccount');
const vehicleLogin = config.get('vehicleLogin');
const operationVehicleLogout = config.get('operationVehicleLogout');
const activateDeactivate = config.get('activateDeactivate');
const activateStatus = config.get('activateStatus')
const download = config.get('download');
const toExcel = config.get('toExcel');
const category = config.get('category');
const platenoFleetCode = config.get('platenoFleetCode');
const vehicleOwner = config.get('vehicleOwner');
const vehicleType = config.get('vehicleType');
const vehicleStatus = config.get('vehicleStatus');
const shipper = config.get('shipper');
const consignee = config.get('consignee');
const barcodeGenerator = config.get('barcodeGenerator');
const tray = config.get('tray');
const getBoxHistory = config.get('getBoxHistory');
const getBoxes = config.get('getBoxes');
const deActivate = config.get('deActivate');
const exceptionSubReason = config.get('exceptionSubReason');

const getOdometer = config.get('getOdometer');
const vehicleMake = config.get('vehicleMake');
const vehicleModel = config.get('vehicleModel');
const loadType = config.get('loadType');
const bodyType = config.get('bodyType');
const vehicleBranding = config.get('vehicleBranding');
const fuelType = config.get('fuelType');
const purchaseMode = config.get('purchaseMode');
const additionalPermit = config.get('additionalPermit');
const gpsStatus = config.get('gpsStatus');

const all = config.get('all');
const nonPlateNumber = config.get("nonPlateNumber");
const adhocVehicles = config.get('adhocVehicles');
const user = config.get('user');
const resetPassword = config.get('resetPassword');
const reportURL = process.env.REACT_APP_TMS_REPORT_SERVICE;
const fleetManagementURL = process.env.REACT_APP_TMS_FLEET_MANAGEMENT_SERVICE
const commonUrl = process.env.REACT_APP_TMS_COMMON_SERVICE;

export const getExceptionListService = async () => {
  try {
    return await AjexPortalService.get(`${exceptionReason}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    getNotificationStyle(err?.response);

    return err?.response;
  }
}

export const GetExceptionPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${exceptionReason}/${all}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const GetExceptionSubReasonService = async (exceptionId: number) => {
  try {
    return await AjexPortalService.get(`${exceptionReason}/${exceptionSubReason}/${exceptionId}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const getCustomerListService = async (pageNumber: number, pageSize: number, isFinance: boolean = false) => {
  try {
    //https://apps-sit.aj-ex.com/tms-booking-service/api/v1/customer/customer-list-view-user?pageNumber=1&pageSize=0&isFinance=true
    return await AjexPortalService.get(`${customer}/${customerListViewUser}?${index}=${pageNumber}&${count}=${pageSize}&isFinance=${isFinance}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    getNotificationStyle(err?.response);

    return err?.response;

  }
}


export const getEmployeeListService = async () => {
  try {
    return await AjexPortalService.get(`${employee}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    getNotificationStyle(err?.response);

    return err?.response;

  }
}

export const GetEmployeePageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${employee}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetAdhocEmployeesService = async (paginationParams: PaginationParams, filterParams?: IEmployeeMasterFilterParams) => {
  const { employeeId, employeeName } = filterParams || {};
  const { current, pageSize } = paginationParams || {};
  try {
    return await AjexPortalService.get(`${employee}/adhoc/${paginated}?${page}=${current}&${size}=${pageSize}&employeeId=${employeeId ?? ""}&name=${employeeName ?? ""}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}

export const GetNonAdhocEmployeesService = async (paginationParams: PaginationParams, filterParams?: IEmployeeMasterFilterParams) => {
  const { employeeId, employeeName } = filterParams || {};
  const { current, pageSize } = paginationParams || {};
  try {
    return await AjexPortalService.get(`${employee}/non-adhoc/${paginated}?${page}=${current}&${size}=${pageSize}&employeeId=${employeeId ?? ""}&name=${employeeName ?? ""}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}

export const getVehicleListService = async () => {
  try {
    return await AjexPortalService.get(`${vehicle}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const getAdhocVehiclesService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/${adhocVehicles}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetNonAdhocVehiclesService = async (paginationParams: PaginationParams, filterParams?: IVehicleMasterFilterParams) => {
  const { current, pageSize } = paginationParams || {};
  const { plateNumber } = filterParams || {};
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/non-adhoc-vehicles/${paginated}?${page}=${current}&${size}=${pageSize}&plateNumber=${plateNumber ?? ""}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}

export const GetAdhocVehiclesService = async (paginationParams: PaginationParams, filterParams?: IVehicleMasterFilterParams) => {
  const { current, pageSize } = paginationParams || {};
  const { plateNumber } = filterParams || {};
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/adhoc-vehicles/${paginated}?${page}=${current}&${size}=${pageSize}&plateNumber=${plateNumber ?? ""}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}

export const getCityListService = async () => {
  try {
    return await AjexPortalService.get(`${city}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    return err?.response;

  }
}

export const GetCityPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${city}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const getEventListService = async () => {
  try {
    return await AjexPortalService.get(`${event}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetEventPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${event}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const getTripRouteListService = async () => {
  try {
    return await AjexPortalService.get(`${tripRoute}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetTripRoutePageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${tripRoute}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetCountryService = async () => {
  try {
    return await AjexPortalService.get(`${country}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetCountryPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${country}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetRegionService = async () => {
  try {
    return await AjexPortalService.get(`${region}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const GetRegionPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${region}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const GetOdaService = async () => {
  try {
    return await AjexPortalService.get(`${odaCity}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}

export const GetOdaPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${odaCity}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}

export const GetProductService = async () => {
  try {
    return await AjexPortalService.get(`${product}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;
  }
}
export const SaveCountryService = async (data: ICountryResponse) => {
  try {
    return await AjexPortalService.post(`${country}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
}
export const SaveCityService = async (data: ICityResponse) => {
  try {
    return await AjexPortalService.post(`${city}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
}
export const SaveRegionService = async (data: IRegionResponse) => {
  try {
    return await AjexPortalService.post(`${region}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
}
export const SaveOdaService = async (data: IOdaResponse) => {
  try {
    return await AjexPortalService.post(`${odaCity}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
}
export const SaveTripRouteService = async (data: ITripRouteResponse) => {
  try {
    return await AjexPortalService.post(`${tripRoute}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
}
export const SaveProductService = async (data: IProductResponse) => {
  try {
    return await AjexPortalService.post(`${product}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveEmployeeService = async (data: IEmployeeResponse) => {
  try {
    return await AjexPortalService.post(`${employee}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveEventService = async (data: IEventResponse) => {
  try {
    return await AjexPortalService.post(`${event}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveExceptionService = async (data: IExceptionResponse) => {
  try {
    return await AjexPortalService.post(`${exceptionReason}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleService = async (data: IVehicleResponse) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${vehicle}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveStationService = async (data: IStationResponse) => {
  try {
    return await AjexPortalService.post(`${station}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteCountryByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${country}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteRegionByIdService = async (id: number | undefined) => {
  try {

    return await AjexPortalService.delete(`${region}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteProductByIdService = async (id: number | undefined) => {
  try {

    return await AjexPortalService.delete(`${product}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteCityByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${city}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteTripRouteByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${tripRoute}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteVehicleByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${vehicle}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteEventByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${event}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteExceptionByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${exceptionReason}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeActivateExceptionByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.put(`${exceptionReason}/${deActivate}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeActivateEmployeeByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.put(`${employee}/${deActivate}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const GetOdometerByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/${getOdometer}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}


export const DeleteOdaByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${odaCity}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteEmployeeByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${employee}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteStationByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${station}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const GetProductPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${product}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const GetStationPageService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${station}/${paginated}?${page}=${pageNumber}&${size}=${pageSize}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const GetStationByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${station}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const GetEmployeeByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${employee}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const GetVehicleByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const UpdateEmployeeService = async (id: number | undefined, data: IEmployeeResponse) => {
  try {
    return await AjexPortalService.put(`${employee}/${id}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response
  }
}

export const UpdateStationService = async (id: number | undefined, data: IStationResponse) => {
  try {
    return await AjexPortalService.put(`${station}/${id}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response
  }
}

export const UpdateVehicleService = async (id: number | undefined, data: IVehicleResponse) => {
  try {
    return await AjexPortalService.put(`${fleetManagementURL}${vehicle}/${id}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response
  }
}
export const CustomerBlockByIdService = async (id: number | undefined, request: IBlockRequest) => {
  try {
    //master/agreement-master-all
    return await AjexPortalService.put(`${customer}/${blockCustomer}/${id}`, request);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const CustomerUnBlockByIdService = async (id: number | undefined) => {
  try {
    //master/agreement-master-all
    return await AjexPortalService.put(`${customer}/${unBlockCustomer}/${id}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SubAccountBlockByIdService = async (id: number | undefined, request: IBlockRequest) => {
  try {
    //master/agreement-master-all
    return await AjexPortalService.put(`${customer}/${block}/${subAccount}/${id}`, request);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const GetVehiclesLoggedInDetailsService = async (pageNumber: number, pageSize: number) => {
  try {
    return await AjexPortalService.get(`${vehicle}/${vehicleLogin}?${page}=${pageNumber}&${size}=${pageSize}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const UpdateVehiclesLoggedInDetailsService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.put(`${vehicle}/${operationVehicleLogout}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const ActivateByIdService = async (id: number | undefined, isActive: number | undefined) => {
  try {
    return await AjexPortalService.put(`${vehicle}/${activateDeactivate}/${id}/${activateStatus}/${isActive}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const ExportAdhocVehiclesService = async () => {
  try {
    return await AjexPortalService.get(`${reportURL}/${vehicle}/${download}/adhoc-vehicles/${toExcel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const ExportNonAdhocVehiclesService = async () => {
  try {
    return await AjexPortalService.get(`${reportURL}/${vehicle}/${download}/non-adhoc-vehicles/${toExcel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetCategoryListService = async () => {
  try {
    return await AjexPortalService.get(`${category}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetPlateAndFleetListService = async () => {
  try {
    return await AjexPortalService.get(`${vehicle}/${platenoFleetCode}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const ExportEmployeeService = async () => {
  try {
    //employee/download/to-excel
    return await AjexPortalService.get(`${reportURL}/${employee}/${download}/${toExcel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const ExportNonAdhocEmployeeService = async () => {
  try {
    return await AjexPortalService.get(`${reportURL}/${employee}/${download}/non-adhoc-employees/${toExcel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const ExportAdhocEmployeeService = async () => {
  try {
    return await AjexPortalService.get(`${reportURL}/${employee}/${download}/adhoc-employees/${toExcel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetOwnerListService = async () => {
  try {
    return await AjexPortalService.get(`${vehicleOwner}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetVehicleTypeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicleType}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleStatusListService = async () => {
  try {
    return await AjexPortalService.get(`${vehicleStatus}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const SaveOwnerService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${vehicleOwner}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleTypeService = async (data: IVehicleTypeRequest) => {
  try {
    return await AjexPortalService.post(`${vehicleType}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteShipperByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${shipper}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const DeleteConsigneeByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.delete(`${consignee}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

// Box&TrayBarcode 
//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/barcode-generator/tray
export const GetListOfTrayBarCodesService = async () => {
  try {
    return await AjexPortalService.get(`${barcodeGenerator}/${tray}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/barcode-generator/get-box-history/63
export const GetBoxesHistoryByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${barcodeGenerator}/${getBoxHistory}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/barcode-generator/get-boxes
export const GetListOfBoxesService = async () => {
  try {
    return await AjexPortalService.get(`${barcodeGenerator}/${getBoxes}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

//https://apps-sit.aj-ex.com/tms-booking-service/api/v1/barcode-generator
export const SaveBarCodeGeneratorService = async (request: ICodeGenerator) => {
  try {
    return await AjexPortalService.post(`${barcodeGenerator}`, request)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const SearchEmployeeService = async (request?: ISearchEmployeeRequest) => {
  try {
    const { employeeId, name } = request || {};
    const url = employeeId ? `employeeId=${employeeId}` : `name=${name}`
    return await AjexPortalService.get(`${employee}/${filter}?${url}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const GetVehicleMakeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicleMake}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleModelListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicleModel}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleLoadTypeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${loadType}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleBodyTypeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${bodyType}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleBrandingListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicleBranding}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};
export const GetVehicleFuelTypeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${fuelType}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetVehicleGPSStatusListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${gpsStatus}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};


export const GetVehicleLeaseTypeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}lease-type`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};


export const GetVehiclePurchaseModeListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${purchaseMode}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const GetAdditonalPermitListService = async () => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${additionalPermit}`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const SaveVehicleMakeService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${vehicleMake}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const SaveVehicleModelService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${vehicleModel}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleLoadTypeService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${loadType}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleBodyTypeService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${bodyType}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleBrandingService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${vehicleBranding}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehicleFuelTypeService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${fuelType}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveVehiclePurchaseModeService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${purchaseMode}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}
export const SaveAdditonalPermitService = async (data: IOwnerRequest) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}${additionalPermit}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}

export const getTrailerListService = async () => {
  try {
    return await AjexPortalService.get(
      `${fleetManagementURL}${vehicle}/${nonPlateNumber}`
    );
    // https://apps-sit.aj-ex.com/tms-fleet-management-service/api/v1/vehicle/non-plate-number-units
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};
export const PickupExceptionListService = async (payload) => {
  try {
    const { page, size, waybillNo, startDate, endDate, exceptionIds, originCityId, destCityId, industryGroupIdList } = payload;
    const queryParams = new URLSearchParams();
    if (!!page) queryParams.append('page', page.toString());
    if (!!size) queryParams.append('size', size.toString());
    // if (createdById !== undefined) queryParams.append('createdById', createdById.toString());
    if (!!waybillNo) queryParams.append('waybillNo', waybillNo);
    if (!!startDate) queryParams.append('startDate', startDate);
    if (!!endDate) queryParams.append('endDate', endDate);
    if (!!exceptionIds) queryParams.append('exceptionIds', exceptionIds.toString());
    if (!!originCityId) queryParams.append('orgCityId', originCityId.toString())
    if (!!destCityId) queryParams.append('destCityId', destCityId.toString())
    if (!!industryGroupIdList?.length && industryGroupIdList !== undefined) queryParams.append('industryGroupId', industryGroupIdList.join(","));

    return await AjexPortalService.get(`${commonUrl}pickup/exception-paginated?${queryParams.toString()}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const DeliveryExceptionListService = async (payload) => {
  try {
    const { page, size, waybillNo, startDate, endDate, exceptionIds, originCityId, destCityId, industryGroupIdList } = payload;
    const queryParams = new URLSearchParams();
    if (!!page) queryParams.append('page', page.toString());
    if (!!size) queryParams.append('size', size.toString());
    // if (createdById !== undefined) queryParams.append('createdById', createdById.toString());
    if (!!waybillNo) queryParams.append('waybillNo', waybillNo);
    if (!!startDate) queryParams.append('startDate', startDate);
    if (!!endDate) queryParams.append('endDate', endDate);
    if (!!exceptionIds) queryParams.append('exceptionIds', exceptionIds.toString())
    if (!!originCityId) queryParams.append('orgCityId', originCityId.toString())
    if (!!destCityId) queryParams.append('destCityId', destCityId.toString())
    if (!!industryGroupIdList?.length && industryGroupIdList !== undefined) queryParams.append('industryGroupId', industryGroupIdList.join(","));
    return await AjexPortalService.get(`${commonUrl}delivery/exception-paginated?${queryParams.toString()}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};

export const UploadWaybillExceptionFileService = async (request) => {
  try {
    const configuration = {
      headers: { 'Content-Type': 'multipart/form-data' }
    };
    return await AjexPortalService.post(`${commonUrl}file-attachment/upload-multiple-file`, request, configuration)
  } catch (error: unknown) {
    const err = error as AxiosError
    getNotificationStyle(err?.response);
    return (err?.response)
  }
}

export const SaveAuthDataService = async (data: IAuthDataRequest) => {
  try {
    return await AjexPortalService.post(`${commonUrl}${user}/${resetPassword}`, data)
  } catch (error: unknown) {
    const err = error as AxiosError;
    // getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const getRegionListByCountryIdService = async (countryId: string | undefined | number) => {
  try {

    return await AjexPortalService.get(`region/country-id/${countryId}`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
export const getHubListByRegionIdService = async (regionId: string | undefined | number) => {
  try {

    return await AjexPortalService.get(`region/${regionId}/hubs`);
  } catch (error: unknown) {
    const err = error as AxiosError
    return err?.response;

  }
}
const occServiceUrl = process.env.REACT_APP_TMS_OCC_SERVICE ?? '';

export const GetAllOccVehiclesService = async () => {
  try {
    const req = {
      role: "ROLE_VT_HOD",
    }
    return await AjexPortalService.post(`${occServiceUrl}occ/get-solutions-vehicles`, req);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};



export const SaveVehicleReplacementService = async (data: any, id: number) => {
  try {
    return await AjexPortalService.post(`${fleetManagementURL}vehicle/add-replacement-vehicle/${id}`, data);
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const CreateRequestService = async (
  id: number | undefined,
  data: any
) => {
  try {
    return await AjexPortalService.post(
      `${fleetManagementURL}${vehicle}/create-request/${id}`,
      data
    );
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);

    return err?.response;
  }
};


export const GetRequestByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/get-request/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};


export const GetVehicleStatusByIdService = async (id: number) => {
  try {
    return await AjexPortalService.get(`${fleetManagementURL}${vehicle}/get-vehicle-status-history/${id}`);
  } catch (error: unknown) {
    const err = error as AxiosError;
    return err?.response;
  }
};

export const GetVehicleRequestFilesTypesListService = async () => {
  try {
    return await AjexPortalService.get(
      `${commonUrl}file-attachment/get-vehicle-request-file-types`
    );
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};

export const getOtherSellerTypeListService = async () => {
  try {
    return await AjexPortalService.get(`other-seller-type`);
    // (`${barcodeGenerator}/${getBoxHistory}/${id}`)
    // https://apps-sit.aj-ex.com/tms-booking-service/api/v1/other-seller-type
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};








export const GetTripRouteByIdService = async (id: number | undefined) => {
  try {
    return await AjexPortalService.get(`${tripRoute}/${id}`)
  } catch (error: unknown) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
}


export const ExportTripRoutesExcelService = async () => {
  try {
    return await AjexPortalService.get(`${reportURL}/report/download/trip-route/export-to-excel`);
  } catch (error) {
    const err = error as AxiosError;
    getNotificationStyle(err?.response);
    return err?.response;
  }
};